import VueRouter from 'vue-router';
// import ManualWT from './views/manualWarehouseTransferView.vue';
// import ManualSI from './views/manualSiteInstallView.vue';
import Reporting from './views/reportingView.vue';
// import ManualSA from './views/manualStockAdjustmentView.vue';
import SubcontractorStock from './views/subcontractorStockView.vue';
import TotalStock from './views/totalStockView.vue';
import Alerts from './views/alertsView.vue';
import Admin from './views/adminView.vue';
import Dupe from './views/duplicatesView.vue';
import Transmutation from './views/stockTransmutationView.vue';
import HighValue from './views/highValueItemsView.vue';

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', redirect: 'HighValueItems' },
    { path: '/HighValueItems', name: 'highvalue', component: HighValue },
    {
      path: '/EquipmentStock',
      name: 'mainstock',
      component: TotalStock,
    },
    {
      path: '/SubcontractorStock',
      name: 'subco',
      component: SubcontractorStock,
    },
    // { path: '/ManualWT', name: 'manualWT', component: ManualWT },
    // { path: '/ManualSI', name: 'manualSI', component: ManualSI },
    { path: '/Reporting', name: 'Reporting', component: Reporting },
    // { path: '/ManualSA', name: 'ManualSA', component: ManualSA },
    { path: '/Settings/Alerts', name: 'alerts', component: Alerts },
    { path: '/Settings/Admin', name: 'admin', component: Admin },
    { path: '/Settings/Duplicates', name: 'dupes', component: Dupe },
    { path: '/transmute', name: 'transmutation', component: Transmutation },
    { path: '*', redirect: 'HighValueItems' },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js